import { checkPrivileges } from "../Helpers";
import { ReactComponent as accountsIcon } from "./../assets/nav/accounts.svg";
import { ReactComponent as DashboardIcon } from "./../assets/nav/dashboard.svg";
import { ReactComponent as usersIcon } from "./../assets/nav/users.svg";
import { ReactComponent as unitsIcon } from "./../assets/nav/units.svg";
import { ReactComponent as groupsIcon } from "./../assets/nav/groups.svg";
import { ReactComponent as serverSettingsIcon } from "./../assets/nav/server-settings.svg";
import { ReactComponent as sysLogsIcon } from "./../assets/nav/sys-logs.svg";
import { ReactComponent as roleManageIcon } from "./../assets/nav/role-manage.svg";
import { ReactComponent as contractMgmtIcon } from "./../assets/nav/contractMgmt.svg";
import { ReactComponent as invoiceIcon } from "./../assets/nav/invoice.svg";
import { ReactComponent as processInvoice } from "./../assets/nav/processs-invoice.svg";
import { ReactComponent as manualInvoice } from "./../assets/nav/manual-invoice.svg";
import { ReactComponent as viewInvoices } from "./../assets/nav/view-invoice.svg";
import { ReactComponent as DeliveryIcon } from "./../assets/nav/sticky-note-01.svg";
import { ReactComponent as OutOfContract } from "./../assets/nav/out-of-contracat-01.svg";
import { ReactComponent as MissedOpportunity } from "./../assets/nav/mised-opportunity-01.svg";
import { ReactComponent as tempGenIcon } from "./../assets/nav/tem-gen.svg";
import { ReactComponent as trashIcon } from "./../assets/nav/trash.svg";
import { ReactComponent as couponIcon } from "./../assets/nav/voucher.svg";
import { ReactComponent as accountsSettings } from "./../assets/nav/accountsSettings.svg";
import { ReactComponent as actionLog } from "./../assets/nav/actionLog.svg";
import { ReactComponent as vehicleIcon } from "./../assets/nav/vehicle.svg";
import { ReactComponent as Garage } from "./../assets/nav/garage-icon.svg";
import { ReactComponent as EXDB } from "./../assets/nav/exDB.svg";
import { ReactComponent as B2C } from "./../assets/nav/b2c.svg";
import { ReactComponent as Speaker } from "./../assets/nav/loud-speaker.svg";
import { ReactComponent as ScheduleIcon } from "./../assets/nav/schedule.svg";
import { ReactComponent as SimahIcon } from "./../assets/nav/simah.svg";
import { ReactComponent as TriggersIcon } from "./../assets/nav/trigger.svg";
import { ReactComponent as ServiceGuardIcon } from "./../assets/nav/service-guard.svg";
import { ReactComponent as IntegrationIcon } from "./../assets/nav/Integration.svg";
import { ReactComponent as MaicIntegrationIcon } from "./../assets/nav/maic-integration.svg";
import { ReactComponent as UnSyncedItemIcon } from "./../assets/nav/unsynced-Items.svg";
import { ReactComponent as CRC } from "./../assets/nav/customer-request-center.svg";
import { ReactComponent as ViewCarIcon } from "./../assets/nav/ViewCar.svg";
import { ReactComponent as MakeIcon } from "./../assets/nav/car-model.svg";
import { ReactComponent as ExpiryIcon } from "./../assets/nav/expire-date.svg";

/** Sidebar section order and labels (keys map to buildNavigation entries). */
export const NAV_SECTIONS = [
  {
    id: "analytics",
    titleKey: "navSectionAnalytics",
    keys: [
      "ex_dashboard",
      "sale_dashboard",
      "business_dashboard",
      "maintenance_dashboard",
    ],
  },
  {
    id: "customers",
    titleKey: "navSectionCustomers",
    keys: ["accounts", "users", "b2c", "crc", "contractManagment"],
  },
  {
    id: "billing",
    titleKey: "navSectionBilling",
    keys: [
      "invoice",
      "deliveryNote",
      "quotations",
      "serviceGuard",
      "simah",
    ],
  },
  {
    id: "operations",
    titleKey: "navSectionOperations",
    keys: [
      "scheduleReportsAndNotifications",
      "missingItems",
      "missedOpportunities",
      "payment",
      "vehicle",
      "workshop",
      "commutator_module",
      "offers",
      "credit_debit_notes",
      "reports",
      "triggers",
    ],
  },
  {
    id: "system",
    titleKey: "navSectionSystem",
    keys: [
      "units",
      "maicintegration",
      "serverSettings",
      "systemLogs",
      "actionLogs",
      "roleManagement",
      "templateGenerator",
      "trash",
      "coupon",
      "accountsSettings",
      "webHooks",
    ],
  },
];

export const buildNavigation = (userInfo = {}, translate = (k) => k) => ({
  ex_dashboard: {
    checked: checkPrivileges("excetiveDashboard"),
    href: "/ex_dashboard",
    icon: EXDB,
    title: translate("ex_dashboard"),
  },
  // cc_dashboard: {
  //   checked: checkPrivileges("cashDashboard"),
  //   href: "/cc_dashboard",
  //   icon: EXDB,
  //   title: translate("cc_dashboard"),
  // },
  sale_dashboard: {
    checked: checkPrivileges("salesDashboard"),
    href: "/sale_dashboard",
    icon: EXDB,
    title: translate("saleKPIDashboard"),
  },
  business_dashboard: {
    checked:  checkPrivileges("businessDashboard"),
    href: "/business_dashboard",
    icon: EXDB,
    title: "businessDashboard",
  },
  maintenance_dashboard: {
    checked: checkPrivileges("maintenanceDashboard"),
    href: "/maintenance_dashboard",
    icon: DashboardIcon,
    title: translate("dashboard"),
  },
  accounts: {
    checked:
      checkPrivileges("account") &&
      userInfo.userType !== 3 &&
      userInfo.roleId !== 57 &&
      userInfo.roleId !== 58 &&
      userInfo.userType !== 2,
    href: "/accounts",
    icon: accountsIcon,
    title: "accounts",
  },
  users: {
    checked: checkPrivileges("user"),
    href: "/users",
    icon: usersIcon,
    title: "users",
  },
  b2c: {
    checked: checkPrivileges("accountCustomerProfile"),
    href: "/b2c",
    icon: B2C,
    title: "customerProfile",
  },
  crc: {
    checked: checkPrivileges("ticket"),
    href: "/crc",
    icon: CRC,
    title: "crc",
  },
  contractManagment: {
    checked: checkPrivileges("expensetype"),
    href: "/contractManagement",
    icon: contractMgmtIcon,
    title: "contractManagement",
  },
  invoice: {
    checked: checkPrivileges("invoice"),
    href: "/invoice",
    icon: invoiceIcon,
    parentIcon: viewInvoices,
    title: "invoices",
    children: [
      {
        checked: checkPrivileges("porequest"),
        href: "/process-invoices",
        icon: processInvoice,
        title: "processInvoices",
      },
      {
        checked: checkPrivileges("manualinvoice"),
        href: "/mannual-invoice",
        icon: manualInvoice,
        title: "manualInvoice",
      },
      {
        checked: checkPrivileges("invoice"),
        href: "/garage-invoices",
        icon: viewInvoices,
        title: "workshopInvoices",
      },
    ],
  },
  deliveryNote: {
    checked: checkPrivileges("deliverynote"),
    href: "/delivery-note",
    icon: DeliveryIcon,
    title: "deliveryNote",
  },
  quotations: {
    checked:
      checkPrivileges("quote"),
    href: "/quotation",
    icon: invoiceIcon,
    title: "quotations",
  },
  serviceGuard: {
    checked:checkPrivileges("serviceGuard"),
    href: "/service-guard",
    icon: ServiceGuardIcon,
    title: "serviceGuard",
  },
  simah: {
    checked: checkPrivileges("creditbureauSimah"),
    href: "/simah",
    icon: SimahIcon,
    title: "creditBureau",
  },
  scheduleReportsAndNotifications: {
    checked: checkPrivileges("broadcastCreate"),
    href: "/schedule-Reports-And-Notifications",
    icon: ScheduleIcon,
    title: "scheduleReportsAndNotifications",
  },
  missingItems: {
    checked: checkPrivileges("outOfContract"),
    href: "/missing-items",
    icon: OutOfContract,
    parentIcon: OutOfContract,
    title: "notInContract",
    children: [
      {
        checked: checkPrivileges("outOfContract"),
        href: "/missing-items",
        icon: OutOfContract,
        title: "missingItems",
      },
      {
        checked: checkPrivileges("outOfContract"),
        href: "/service-missing-items",
        icon: OutOfContract,
        title: "serviceMissingItems",
      },
    ],
  },
  missedOpportunities: {
    checked: checkPrivileges("aiPms"),
    href: "/missed-opportunities",
    icon: MissedOpportunity,
    parentIcon: MissedOpportunity,
    title: "missedOpportunities",
    ...(userInfo.userType === -1
      ? {
          children: [
            {
              checked: checkPrivileges("aiPms"),
              href: "/missed-opportunities",
              icon: MissedOpportunity,
              title: "missedOpportunities",
            },
            {
              checked: checkPrivileges("aiPms"),
              href: "/user-pms",
              icon: MissedOpportunity,
              title: "userPms",
            },
          ],
        }
      : {}),
  },
  payment: {
    checked: checkPrivileges("payment"),
    href: "/new_payment",
    icon: groupsIcon,
    parentIcon: groupsIcon,
    title: "payments",
    children: [
      {
        checked: checkPrivileges("payment"),
        href: "/workshop-payment",
        icon: Garage,
        title: "workshopPayment",
      },
    ],
  },
  vehicle: {
    checked: checkPrivileges("vehicle"),
    href: "/vehicle",
    icon: ViewCarIcon,
    parentIcon: vehicleIcon,
    title: "fleet",
    children: [
      {
        checked: checkPrivileges("vehicle"),
        href: "/vehicle-expiry",
        icon: ExpiryIcon,
        title: "fleetExpiry",
      },
      {
        checked: checkPrivileges("vehicle"),
        href: "/vehicle-makes",
        icon: MakeIcon,
        title: "vehicleMakes",
      },
      {
        checked: checkPrivileges("vehicle"),
        href: "/vehicle-models",
        icon: MakeIcon,
        title: "vehicleModels",
      },
    ],
  },
  workshop: {
    checked: checkPrivileges("garage"),
    href: "/workshops",
    icon: Garage,
    title: "workshops",
  },
  commutator_module: {
    checked: checkPrivileges("broadcastCreate"),
    href: "/commutator",
    icon: Speaker,
    title: "campaign",
  },
  offers: {
    checked: checkPrivileges("role"),
    href: "/offers",
    icon: couponIcon,
    title: "offers",
  },
  credit_debit_notes: {
    checked: checkPrivileges("creditdebitnote"),
    href: "/credit_debit_notes",
    icon: tempGenIcon,
    title: "credit-debit notes",
  },
  reports: {
    checked: checkPrivileges("report"),
    href: "/reports",
    icon: couponIcon,
    title: "reports",
  },
  triggers: {
    checked: checkPrivileges("invoiceTrigger"),
    href: "/triggers",
    icon: TriggersIcon,
    title: "monthlyInvs&Dn",
  },
  units: {
    checked: checkPrivileges("device") && userInfo.userType !== 6,
    href: "/units",
    icon: unitsIcon,
    title: "units",
  },
  maicintegration: {
    checked: checkPrivileges("device") && userInfo.userType === -1,
    href: "/maic-integration",
    icon: IntegrationIcon,
    parentIcon: IntegrationIcon,
    title: "Integration",
    children: [
      {
        checked: checkPrivileges("device") && userInfo.userType === -1,
        href: "/maic-integration",
        icon: MaicIntegrationIcon,
        title: "MAIC Integration",
      },
      {
        checked: checkPrivileges("device") && userInfo.userType === -1,
        href: "/unsynced-items",
        icon: UnSyncedItemIcon,
        title: "unsyncedItems",
      },
    ],
  },
  serverSettings: {
    checked: checkPrivileges("account") && userInfo.userType === -1,
    href: "/serverSettings",
    icon: serverSettingsIcon,
    title: "serverSettings",
  },
  systemLogs: {
    checked:
      userInfo.userType === -1 &&
      userInfo.roleId !== 57 &&
      userInfo.roleId !== 58,
    href: "/systemLogs",
    icon: sysLogsIcon,
    title: "systemLogs",
  },
  actionLogs: {
    checked: checkPrivileges("actionlogAllUsers"),
    href: "/actionLogs",
    icon: actionLog,
    title: "actionLogs",
  },
  roleManagement: {
    checked: checkPrivileges("role"),
    href: "/roleManagement",
    icon: roleManageIcon,
    title: "roleManagement",
  },
  templateGenerator: {
    checked: checkPrivileges("tempGenerator") && userInfo.userType !== 6,
    href: "/templateGenerator",
    icon: tempGenIcon,
    title: "templateGenerator",
  },
  trash: {
    checked: userInfo.roleId !== 57 && userInfo.roleId !== 58&&checkPrivileges("trash"),
    href: "/trash",
    icon: trashIcon,
    title: "trash",
  },
  coupon: {
    checked:
      userInfo.roleId !== 57 &&
      userInfo.roleId !== 58 &&
      userInfo.userType === -1,
    href: "/coupon",
    icon: couponIcon,
    title: "coupon",
  },
  accountsSettings: {
    checked: checkPrivileges("account") && userInfo.userType === -1,
    href: "/accountSettings",
    icon: accountsSettings,
    title: "accountSettings",
  },
  webHooks: {
    checked:
      userInfo.roleId !== 57 &&
      userInfo.roleId !== 58 &&
      userInfo.userType === -1,
    href: "/webHooks",
    icon: serverSettingsIcon,
    title: "webHooks",
  },
});

const getParentExtraItems = (item) => {
  if (item.title === "invoices") {
    return [{ href: item.href, title: "viewInvoices", parent: item.title }];
  }
  if (item.title === "fleet") {
    return [{ href: item.href, title: "viewFleet", parent: item.title }];
  }
  if (item.title === "payments") {
    return [{ href: item.href, title: "customerPayments", parent: item.title }];
  }
  return [];
};

export const getSearchableMenuItems = (userInfo = {}, translate = (k) => k) => {
  const navigation = buildNavigation(userInfo, translate);
  const items = [];
  const seen = new Set();

  const pushItem = ({ href, title, parent }) => {
    if (!href || !title) return;
    const key = `${href}__${title}`;
    if (seen.has(key)) return;
    seen.add(key);
    items.push({
      href,
      title,
      label: translate(title),
      parent: parent ? translate(parent) : "",
    });
  };

  Object.values(navigation).forEach((item) => {
    if (!item?.checked) return;

    const childItems = (item.children || []).filter((child) => child.checked);
    getParentExtraItems(item).forEach(pushItem);

    if (childItems.length) {
      childItems.forEach((child) => {
        pushItem({
          href: child.href,
          title: child.title,
          parent: item.title,
        });
      });
    } else {
      pushItem({
        href: item.href,
        title: item.title,
      });
    }
  });

  return items;
};
